export type SupportedLocaels = 'en' | 'de' | 'fr' | 'nl' | 'sv' | 'fi';

type WebappTranslationImports = {
  [Key in SupportedLocaels]: () => Promise<{ [k in Key]: Record<string, any> }>;
};

export const appTranslations: WebappTranslationImports = {
  en: () => import('../assets/en.json').then(translations => ({ en: translations })),
  de: () => import('../assets/de.json').then(translations => ({ de: translations })),
  fr: () => import('../assets/fr.json').then(translations => ({ fr: translations })),
  nl: () => import('../assets/nl.json').then(translations => ({ nl: translations })),
  sv: () => import('../assets/sv.json').then(translations => ({ sv: translations })),
  fi: () => import('../assets/fi.json').then(translations => ({ fi: translations })),
};
